import type { PolymorphicVariantDef } from '@doer/frontend-components/creativity-editor';
import { buildPillPair } from './pill-pair';
import { buildPaymentMethodHighlightText } from '../text/payment-method-highlight-text';

// Variant templates for payment-method-highlight. The polymorphic binder mounts the active one.
// `top` is a placeholder — each template overrides it via `positionsByResolution` in its fieldBinding.

const textVariant: PolymorphicVariantDef = {
  pieces: [
    buildPaymentMethodHighlightText({
      pieceId: 'payment-method-highlight-text',
      text: 'Pagando con tu celular sin contacto',
      fontSize: 34,
      position: { left: 540, top: 1179, width: 642.954, height: 38.42 }
    })
  ],
  bindings: [{ pieceId: 'payment-method-highlight-text', bindingType: 'text', from: 'value' }]
};

const pillPairVariant: PolymorphicVariantDef = {
  pieces: [
    buildPillPair({
      groupPieceId: 'payment-method-highlight-pair',
      left: {
        pieceId: 'payment-method-highlight-left',
        text: 'Exclusivo con',
        style: 'white-blue-stroke',
        icon: 'modo-blue'
      },
      right: {
        pieceId: 'payment-method-highlight-right',
        text: 'desde App',
        style: 'white-blue-stroke',
        icon: 'icono'
      },
      position: { left: 540, top: 1176.0911, width: 500, height: 50 }
    })
  ],
  bindings: [
    { pieceId: 'payment-method-highlight-left', bindingType: 'text', from: 'left' },
    { pieceId: 'payment-method-highlight-right', bindingType: 'text', from: 'right' }
  ]
};

const pillPairInvertedVariant: PolymorphicVariantDef = {
  pieces: [
    buildPillPair({
      groupPieceId: 'payment-method-highlight-pair-inv',
      left: {
        pieceId: 'payment-method-highlight-left-inv',
        text: 'Pagá con',
        style: 'white-blue-stroke',
        icon: 'modo-blue'
      },
      right: {
        pieceId: 'payment-method-highlight-right-inv',
        text: 'desde App',
        style: 'blue-white-stroke',
        icon: 'icono-white'
      },
      position: { left: 540, top: 1176.0911, width: 500, height: 50 }
    })
  ],
  bindings: [
    { pieceId: 'payment-method-highlight-left-inv', bindingType: 'text', from: 'left-inv' },
    { pieceId: 'payment-method-highlight-right-inv', bindingType: 'text', from: 'right-inv' }
  ]
};

export const PAYMENT_METHOD_HIGHLIGHT_VARIANTS = {
  text: textVariant,
  'pill-pair': pillPairVariant,
  'pill-pair-inv': pillPairInvertedVariant
};
